/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NftGatedTrackSignatureData
 */
export interface NftGatedTrackSignatureData {
    /**
     * 
     * @type {string}
     * @memberof NftGatedTrackSignatureData
     */
    data: string;
    /**
     * 
     * @type {string}
     * @memberof NftGatedTrackSignatureData
     */
    signature: string;
}

/**
 * Check if a given object implements the NftGatedTrackSignatureData interface.
 */
export function instanceOfNftGatedTrackSignatureData(value: object): value is NftGatedTrackSignatureData {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;

    return isInstance;
}

export function NftGatedTrackSignatureDataFromJSON(json: any): NftGatedTrackSignatureData {
    return NftGatedTrackSignatureDataFromJSONTyped(json, false);
}

export function NftGatedTrackSignatureDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftGatedTrackSignatureData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
        'signature': json['signature'],
    };
}

export function NftGatedTrackSignatureDataToJSON(value?: NftGatedTrackSignatureData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'signature': value.signature,
    };
}

